import { isFunction } from 'lodash'
import { FluidValue } from '@react-spring/shared'
import { MainTimeline, StageTimeline } from './useAnimationStageTimelines'
import { InterpolatorConfig } from 'react-spring'
import { InterpolatorArgs } from '@react-spring/types'

export type InterpolationOutput = InterpolatorConfig['output']
export type InterpolationRange = InterpolatorConfig['range']

type ToValueRange = (output: InterpolationOutput, range?: [number, number]) => StageTimeline
type ToOverloaded = (...args: InterpolatorArgs) => StageTimeline

export type ExtendPrototype<T> = Omit<T, 'to'> & {
  toValueRange: ToValueRange
  to: ToOverloaded
}

const getPrototypeToExtend = (mainTimeline: MainTimeline) => {
  // @ts-ignore
  const suspectedFluidValue = mainTimeline?.__proto__?.__proto__

  const isActuallyFluidValue = suspectedFluidValue instanceof FluidValue
  if (!isActuallyFluidValue) throw new Error('The internals of react-spring have changed')

  return suspectedFluidValue
}

export const addCustomMethodsToTimelinePrototype = (mainTimeline: MainTimeline) => {
  const prototype = getPrototypeToExtend(mainTimeline) as any

  const isAlreadyExtended = isFunction(prototype?.toValueRange)
  if (isAlreadyExtended) return

  const toValueRange: ToValueRange = function toValueRange(output, range) {
    // @ts-ignore
    return this.to({ output, range: range ?? [0, 1], extrapolate: 'clamp' })
  }

  prototype.toValueRange = toValueRange
}
